import GeneralError from "./generalError";

// eslint-disable-next-line import/prefer-default-export
export { GeneralError };
